<template>
    <div class="background upgradePlanPopup d-flex flex-column align-items-center justify-content-center" v-if="getIsShowingUpgradePlanPopup" @click.self="close">

        <div class="popup radius-normal">
            <div class="text-center fs-large darker bold p-4">
                Your current plan does not support this feature, please contact our team.
            </div>
            <div class="text-center p-4">
                    <button class="btn" @click="pressOk">Contact</button>
            </div>
        </div>

    </div>
</template>

<script>
import { mapGetters, mapActions} from 'vuex'
export default {
    computed: {
        ...mapGetters([
            'getIsShowingUpgradePlanPopup'
        ])
    },
    methods: {
        ...mapActions([
            'showUpgradePlanPopup'
        ]),
        pressOk: function () {
            window.location.href = "mailto:geral@pluralo.com?subject=Upgrade to Invoice System";
            // this.showUpgradePlanPopup(false)
        },
        close: function () {
            this.showUpgradePlanPopup(false)
        }
    }
}
</script>

<style lang="scss" scoped>
.upgradePlanPopup{
    &.background{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.5);
        z-index: 8000;
    }

    .popup{
        background-color: #FFF;
        width: 800px;
        // margin: auto;
        // top: 0;
        // bottom: 0;
        // right: 0;
        // left: 0;
        // height: 300px;
        // position: absolute;
    }
}
</style>



// WEBPACK FOOTER //
// UpgradePlanPopup.vue?21daf1aa